import {useEffect,useState,useRef} from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import {addZero} from '../../util/datetime'

import useCountDown from "react-countdown-hook"

export default function Timer(){

	const countDownIntervalRef = useRef()

	const emptyCountDownState = ()=>({
		activeMs:0,
		restMs:0,
		remainingIntervals:1,
		remainingMs:0,
		mode:'inactive'
	})

	const countDownStateRef = useRef(emptyCountDownState())

	// idle | paused | active
	const [mode,setMode] = useState('idle')

	const [intervals,setIntervals] = useState(0)

	const timerTextRef = useRef()

	//active state
	const [activeHours,setActiveHours] = useState(0)
	const [activeMinutes,setActiveMinutes] = useState(0)
	const [activeSeconds,setActiveSeconds] = useState(0)

	//rest state
	const [restHours,setRestHours] = useState(0)
	const [restMinutes,setRestMinutes] = useState(0)
	const [restSeconds,setRestSeconds] = useState(0)

	const calculateMilliseconds = (seconds,minutes,hours)=>(
		1000*(seconds + 60*( minutes + 60*hours ))
	)

	//given an int number of ms returns object
	//with hours, minutes, seconds
	const parseMs = ms => {
		const hours = Math.floor(ms/1000/60/60)

		ms -= hours*1000*60*60

		const minutes = Math.floor(ms/1000/60)

		ms -= minutes*1000*60

		const seconds = Math.floor(ms/1000)

		return {hours,minutes,seconds}
	}

	const updateTimerText = ()=>{
		const {
			remainingIntervals,
			remainingMs,
			mode
		} = countDownStateRef.current
		const {hours,minutes,seconds} = parseMs(remainingMs)
		timerTextRef.current.innerText = `Intervals:${remainingIntervals}\n${addZero(hours)}:${addZero(minutes)}:${addZero(seconds)}\n(${mode})`
	}

	const intervalTick = (countDownStateRef)=>{
		try {
			//decrement the remaining ms by 1000 (1 second)
			//ensure value doesn't go below 0
			countDownStateRef.current.remainingMs = Math.max(
				countDownStateRef.current.remainingMs - 1000,
				0
			)
			//set the text to display in the 
			updateTimerText()
			//destructure some props for use below
			const {
				activeMs,
				restMs,
				remainingIntervals,
				remainingMs,
				mode
			} = countDownStateRef.current

			//do nothing if paused
			if (mode==='paused') return 
			//if reached the end of an active cycle decrement the number of intervals
			if(remainingMs===0){
				if(mode==='active'&&restMs!==0){
					countDownStateRef.current.remainingIntervals-=1
					//if there are no more active cycles don't move into rest mode
					//instead end the countdown
					if(countDownStateRef.current.remainingIntervals===0){
						reset()
						return 
					}
					//move into rest mode and set the remaining countdown 
					//milliseconds to the restms
					countDownStateRef.current.mode = 'rest'
					countDownStateRef.current.remainingMs = restMs
				}else{
					countDownStateRef.current.mode = 'active'
					countDownStateRef.current.remainingMs = activeMs
				}
			}
			
		} catch (err) {
			console.error(err)
		}
	}

	const handleStart = ()=>{
		clearInterval(countDownIntervalRef.current)
		const activeMs = calculateMilliseconds(
			activeSeconds,
			activeMinutes,
			activeHours
		)

		const restMs = calculateMilliseconds(
			restSeconds,
			restMinutes,
			restHours
		)

		if(activeMs===0) return

		//add 1 second so that timer correctly starts with the total
		//time displayed 
		countDownStateRef.current.activeMs = activeMs + 1000
		countDownStateRef.current.restMs = restMs + 1000
		countDownStateRef.current.remainingMs = activeMs
		countDownStateRef.current.mode = 'active'
		countDownStateRef.current.remainingIntervals = Math.max(intervals,1)

		const intervalId = setInterval(intervalTick,1000,countDownStateRef)

		countDownIntervalRef.current = intervalId
		
	}

	const clearCountdown = ()=>{
		if(!countDownIntervalRef.current) return
		clearInterval(countDownIntervalRef.current)
		countDownStateRef.current = emptyCountDownState()
	}

	const handlePause = ()=>{
		setMode('paused')
		clearCountdown()
	}

	

	const reset = ()=>{
		clearCountdown()

		setActiveHours(0)
		setActiveMinutes(0)
		setActiveSeconds(0)

		setRestHours(0)
		setRestMinutes(0)
		setRestSeconds(0)

		setIntervals(0)

		setMode('idle')

		updateTimerText()
	}

	useEffect(()=>{
		return clearCountdown
	})

	return (
		<div className="pt-5 px-2 px-md-3 d-flex align-items-center justify-content-center">
			<div style={{
				maxWidth:'400px'
			}}>
				<strong>Sets/Intervals</strong>
				<Form.Control 
					type="number"
					min={1}
					onChange={e=>{
						setIntervals(parseInt(e.target.value)||1)
					}}
					className="text-center"
					placeholder="Sets/Intervals"
					value={intervals}
				/>
				<strong>Active Time</strong>
				<div className="d-flex align-items-center">
					<Form.Control
						type="number" 
						className="text-center"
						onChange={e=>{
							setActiveHours(parseInt(e.target.value)||0)
						}}
						placeholder="hours"
						value={activeHours}
					/>
					<span className="mx-1">:</span>
					<Form.Control
						type="number" 
						className="text-center"
						onChange={e=>{
							setActiveMinutes(parseInt(e.target.value)||0)
						}}
						placeholder="minutes"
						value={activeMinutes}
					/>
					<span className="mx-1">:</span>
					<Form.Control
						type="number" 
						className="text-center"
						onChange={e=>{
							setActiveSeconds(parseInt(e.target.value)||0)
						}}
						placeholder="seconds"
						value={activeSeconds}
					/>
				</div>
				<strong>Rest Time</strong>
				<div className="d-flex align-items-center">
					<Form.Control
						type="number" 
						className="text-center"
						onChange={e=>{
							setRestHours(parseInt(e.target.value)||0)
						}}
						placeholder="hours"
						value={restHours}
					/>
					<span className="mx-1">:</span>
					<Form.Control
						type="number" 
						className="text-center"
						onChange={e=>{
							setRestMinutes(parseInt(e.target.value)||0)
						}}
						placeholder="minutes"
						value={restMinutes}
					/>
					<span className="mx-1">:</span>
					<Form.Control
						type="number" 
						className="text-center"
						onChange={e=>{
							setRestSeconds(parseInt(e.target.value)||0)
						}}
						placeholder="seconds"
						value={restSeconds}
					/>
				</div>
				<div className="text-right mt-2">
					<Button 
						variant="outline-dark"
						className="mr-2"
						onClick={reset}
					>
						Reset
					</Button>
					<Button 
						variant="outline-success"
						onClick={handleStart}
					>
						Start
					</Button>
				</div>
				<h1 
					style={{fontFamily:'monospace',whiteSpace:'pre-wrap'}} 
					className="text-center" 
					ref={timerTextRef}
				>
					Intervals:0<br/>
					00:00:00<br/>
					(inactive)
				</h1>
			</div>
		</div>
	)
}